import React from 'react';
import Modal from 'react-modal';
import { formatDisplayDateTime } from '../../../utils';

type TimesheetResendEmailModalProps = {
    isOpen: boolean;
    lastApprovalEmailSentAt?: string | null;
    isSending?: boolean;
    onClose: () => void;
    onSend: () => void;
};

export const TimesheetResendEmailModal: React.FC<TimesheetResendEmailModalProps> = ({
    isOpen,
    lastApprovalEmailSentAt,
    isSending = false,
    onClose,
    onSend,
}) => {
    const formattedLastSentAt = formatDisplayDateTime(lastApprovalEmailSentAt);

    return (
        <Modal
            className="timesheet-resend-modal"
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Resend approval email"
            ariaHideApp={false}
        >
            <div className="timesheet-resend-modal__body">
                <p className="timesheet-resend-modal__text">
                    The last email was sent on {formattedLastSentAt}.
                    {' '}
                    Do you wish to resend the email?
                </p>
            </div>
            <div className="timesheet-resend-modal__actions">
                <button
                    className="timesheet-modal__secondary-btn"
                    type="button"
                    onClick={onClose}
                    disabled={isSending}
                >
                    CLOSE
                </button>
                <button
                    className="timesheet-modal__primary-btn"
                    type="button"
                    onClick={onSend}
                    disabled={isSending}
                >
                    {isSending ? 'SENDING...' : 'SEND'}
                </button>
            </div>
        </Modal>
    );
};

export default TimesheetResendEmailModal;
